// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { List } from './list';
import { createElement } from './common';

/**
 * @class Jsw.ScrollableList
 * The extension of the list widget: fits 100% height of screen.
 * @extends Jsw.List
  */
export const ScrollableList = Class.create(List, {
    listView($super) {
        const view = $super();

        view.attrs.class += ' scrollable-list';
        view.children[0].attrs.class = 'scrollable-list-table';
        view.children = [
            createElement('table.fixed-table-head[width="100%"][cellspacing="0"]',
                this.listHeadersView()
            ),
            createElement('.scrollable-list-wrapper', view.children),
        ];

        return view;
    },

    checkEmptyList($super) {
        $super();

        const isEmpty = this.isListEmpty();
        this._componentElement.select(`.${this._listCls}`).invoke('toggle', true);
        this._componentElement.select('.scrollable-list-wrapper').invoke('toggle', !isEmpty);
    },

    /**
     * @param {Function} $super
     * @param {String} place
     * @param {Number} dataLen
     */
    redraw($super, place, dataLen) {
        let bottom = true;
        let scrollTop;
        let tableHeight = 0;
        const wrapper = $(this._id).down('.scrollable-list-wrapper');

        if (wrapper) {
            bottom = (wrapper.offsetHeight + wrapper.scrollTop >= wrapper.scrollHeight);
            // eslint-disable-next-line prefer-destructuring
            scrollTop = wrapper.scrollTop;
            tableHeight = $(this._tableId).getHeight();
        }

        $super(place, dataLen);
        const table = $(this._tableId);
        const headerTable = table.up(`.${this._listCls}`).down('.fixed-table-head');

        table.setStyle({ marginTop: `${-headerTable.getHeight()}px` });
        setTimeout(function () {
            this._resizeList();
            const wrapper = table.up('.scrollable-list-wrapper');
            if (bottom) {
                this.scrollToBottom();
            } else if ('before' === place) {
                wrapper.scrollTop += table.getHeight() - tableHeight;
            } else if ('after' === place) {
                // empty
            } else {
                wrapper.scrollTop = scrollTop;
            }
        }.bind(this), 0);
    },

    updateFilter($super, force) {
        $super(force);
        this._resizeList();
    },

    scrollToBottom() {
        const table = $(this._tableId);
        const wrapper = table.up('.scrollable-list-wrapper');
        wrapper.scrollTop = wrapper.select('tr').filter(Element.visible).last().offsetTop;
    },

    _resizeList() {
        const minHeight = 200;
        const table = $(this._tableId);
        const wrapper = table.up('.scrollable-list-wrapper');

        const headerTable = table.up(`.${this._listCls}`).down('.fixed-table-head');
        const visibleHeader = headerTable.down('thead');
        if (visibleHeader) {
            const isEmpty = this.isListEmpty();
            visibleHeader.select('tr').each(function (tr) {
                if (!tr.hasClassName('list-search-filter')) {
                    isEmpty ? tr.hide() : tr.show();
                }
            });
        }

        let blockHeight = $(document.body).getHeight() - wrapper.cumulativeOffset().top;
        for (let up = wrapper; up instanceof Element; up = up.up()) {
            blockHeight = blockHeight
                - (parseInt(up.getStyle('borderBottomWidth')) || 0)
                - (parseInt(up.getStyle('marginBottom')) || 0)
                - (parseInt(up.getStyle('paddingBottom')) || 0);
            for (let next = up.next(); next instanceof Element; next = next.next()) {
                if ('none' !== next.getStyle('display') && 'fixed' !== next.getStyle('position') && 'absolute' !== next.getStyle('position')) {
                    blockHeight = blockHeight - next.getHeight();
                }
            }
        }

        if (blockHeight < minHeight) {
            blockHeight = minHeight;
        }

        if (blockHeight > table.getHeight() + parseInt(table.getStyle('marginTop'))) {
            wrapper.setStyle({ height: null });
        } else {
            wrapper.setStyle({ height: `${blockHeight}px` });
        }

        if (!visibleHeader || !table.select('tr.odd,tr.even').filter(Element.visible)) {
            return;
        }

        const invisibleHeader = table.down('thead');
        invisibleHeader.select('th').each(function (th, index) {
            visibleHeader.select('th')[index].setStyle({ width: `${th.getWidth()}px` });
        });
        const lastHeader = visibleHeader.down('th:last');
        lastHeader.setStyle({ width: `${(headerTable.getWidth() - invisibleHeader.up('table').getWidth()) + parseInt(lastHeader.getStyle('width'))}px` });
    },

    _addResponsiveHtml() {
        // Don't need responsive UI in case of logs list
    },

    _addEvents($super) {
        $super();
        Event.observe(
            window,
            'resize',
            this._resizeList.bind(this),
            false
        );
    },
});



// WEBPACK FOOTER //
// ./jsw/scrollable-list.js